// Off-click closes secondary menu
jQuery('.cd-secondary-nav').click(function(e) {
  e.stopPropagation();
});

jQuery('.cd-primary-nav').click(function(e){
    e.stopPropagation();
});

jQuery(document).ready(function() {
  var navChildren = jQuery(".cd-primary-nav .has-children a");
  var navLink = jQuery(".usa-nav-link");
  // Open a dropdown list in desktop, and open a new subnav menu on mobile.
  for (var i = 0; i < navLink.length; i++) {
    navLink[i].addEventListener("click", function() {
      jQuery(this)
        .parent()
        .parent()
        .find("> li")
        .removeClass("menu-active");
      jQuery(this)
        .parent()
        .parent()
        .find("> li")
        .removeClass("menu-is-open");
      jQuery(this)
        .parent()
        .parent()
        .find(".svg-inline--fa")
        .removeClass("fa-chevron-left");
      jQuery(this)
        .parent()
        .parent()
        .find(".svg-inline--fa")
        .addClass("fa-chevron-down");
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");
      var trident = ua.indexOf("Trident/");
      if (msie > 0 || trident > 0) {
        if (jQuery(this).attr("aria-haspopup") === "true") {
          jQuery(this)
            .parent()
            .addClass("menu-active");
          jQuery(this)
            .parent()
            .parent()
            .find("> li")
            .addClass("menu-is-open");
          if (jQuery(document).outerWidth() < 993) {
            jQuery(this)
              .find(".svg-inline--fa")
              .addClass("fa-chevron-left");
            jQuery(this)
              .find(".svg-inline--fa")
              .removeClass("fa-chevron-down");
          }
        }
      } else if (jQuery(this).attr("aria-haspopup") === "false") {
        jQuery(this)
          .parent()
          .addClass("menu-active");
        jQuery(this)
          .parent()
          .parent()
          .find("> li")
          .addClass("menu-is-open");
      }
      jQuery(".usa-nav-submenu").each(function() {
        var padding = jQuery(this)
          .find(".menu-title")
          .outerHeight(true);
        if (jQuery(this).css("padding-top") < padding) {
          jQuery(this).css("padding-top", padding);
        }
      });
    });
  }
  // Open the mobile menu
  var dolMenuButton = jQuery("button.dol-menu-button");
  dolMenuButton[0].addEventListener("click", function() {
    jQuery(".nav-container").toggleClass("nav-is-open");
    jQuery(".agency-nav-container").toggleClass("nav-is-open");
  });
    // When you click outside of the menu or menu button, close everything
  jQuery("html").click(function(event) {
    var $trigger = jQuery("#header-content");
    if ($trigger !== event.target && !$trigger.has(event.target).length) {
      var $triggerAlt = jQuery("button.dol-menu-button");
      if (
        $triggerAlt[0] !== event.target &&
        !$triggerAlt.has(event.target).length
      ) {
        jQuery(".usa-mobile_nav-active").removeClass("usa-mobile_nav-active");
        jQuery(".usa-nav-link").attr("aria-haspopup", function() {
          return "false";
        });
        jQuery(".usa-nav-submenu").attr("aria-hidden", function() {
          return "true";
        });
        var navItem = jQuery(".usa-nav-primary").find("> li > button");
        jQuery.each(navItem, function() {
          if (jQuery(this).hasClass("fa-chevron-left")) {
            jQuery(this).removeClass("fa-chevron-left");
            jQuery(this).addClass("fa-chevron-right");
          }
        });
        jQuery(".cd-primary-nav")
          .find("> li")
          .removeClass("menu-is-active menu-is-open");
        jQuery(".nav-container").removeClass("nav-is-open");
      }
    }
  });
  jQuery(".usa-nav-submenu").click(function(e) {
    e.stopPropagation();
  });

  jQuery(".usa-nav-submenu").each(function() {
    var padding = jQuery(this)
      .find(".menu-title")
      .outerHeight(true);
    if (jQuery(this).css("padding-top") < padding) {
      jQuery(this).css("padding-top", padding);
    }
  });
  if (jQuery(this).outerWidth() <= 992) {
    jQuery("li.has-children").on("click", function (e) {
      if (jQuery(this).find("a").hasClass("selected") === true) {
        jQuery(this).find(".svg-inline--fa").removeClass("fa-chevron-down").addClass("fa-chevron-left");
        jQuery(this).find(".backtext").addClass("showbacktext");
      } else if (jQuery(this).find("a").hasClass("selected") === false) {
        jQuery(this).find(".svg-inline--fa").removeClass("fa-chevron-left").addClass("fa-chevron-down");
        jQuery(this).find(".backtext").removeClass("showbacktext");
      }
    });
  }
});

// When you change between desktop and mobile, change switch fontawesome icon direction
// Call the function only after the window is done resizing.
jQuery(window).on("resize", function() {
  clearTimeout(this.id);
  this.id = setTimeout(doneResizing, 1);
});

// Menu Item Toggle Behavior after Resizing.
function doneResizing() {
  var docWidth = jQuery(window).outerWidth();
  var navChildren = jQuery(".cd-primary-nav .has-children a");
  if (docWidth <= 992) {
    jQuery(navChildren).each(function () {
      // Switches Nav Arrow Direction on Resize.
      var navSelected = jQuery(this).hasClass("selected");
      if (navSelected === true) {
        jQuery(this).find(".svg-inline--fa").addClass("fa-chevron-left").removeClass("fa-chevron-down");
        jQuery(this).find(".backtext").addClass("showbacktext");
      }
    });
    jQuery(".cd-primary-nav .has-children").on("click", function(e) {
      var selectedItem = jQuery(this).find("a.selected");
      if (selectedItem.length) {
        jQuery(this).find(".svg-inline--fa").removeClass("fa-chevron-down").addClass("fa-chevron-left");
        jQuery(this).find(".backtext").addClass("showbacktext");
        jQuery(this).siblings().find(".backtext").removeClass("showbacktext");
      } else {
        jQuery(this).find(".svg-inline--fa").removeClass("fa-chevron-left").addClass("fa-chevron-down");
        jQuery(this).find(".backtext").removeClass("showbacktext");
      }
    });
  }
  else if (docWidth > 992) {
    jQuery(".cd-primary-nav .has-children").on("click", function(e) {
      jQuery(this).find(".svg-inline--fa").removeClass("fa-chevron-left").addClass("fa-chevron-down");
      jQuery(this).siblings(".has-children").find("backtext").removeClass("showbacktext");
    });
  }
}

jQuery(document).on("click", function(e) {
  var dolPrimMenu = jQuery("#dol-primary-menu");
  if (jQuery(e.target).hasClass("usa-menu-btn") === false) {
    jQuery(".cd-primary-nav")
      .find(".backtext")
      .removeClass("showbacktext");
    jQuery(".cd-primary-nav")
      .find(".svg-inline--fa")
      .removeClass("fa-chevron-left")
      .addClass("fa-chevron-down");
  }
  if (jQuery(dolPrimMenu).hasClass("nav-is-open")) {
    jQuery("button.dol-menu-button").text("Close");
    if (jQuery(dolPrimMenu).find("li.menu-is-open.menu-is-active")) {
      jQuery("li.menu-is-open.menu-is-active")
        .find(".cd-secondary-nav")
        .removeClass("is-hidden");
    }
  } else {
    jQuery("button.dol-menu-button").text("Menu");
    jQuery("li.menu-is-open.menu-is-active")
      .find(".cd-secondary-nav")
      .addClass("is-hidden");
  }
});

jQuery(".cd-secondary-nav").click(function(e) {
  e.stopPropagation();
});
//Close menus by pressing Esc key
jQuery(document).on('keydown', function(event) {
  var open = jQuery('ul.cd-primary-nav li.menu-is-open');
  var open_mobile = jQuery('.agency-nav-container.nav-is-open');
  //Close mobile menus
  if (event.keyCode === 27 && open_mobile.length) {
    jQuery('button.dol-menu-button').text('Menu');
    jQuery(open_mobile).removeClass('nav-is-open');
  }
  //Close desktop menus
  if (event.keyCode === 27 && open.length) {
    jQuery('.cd-secondary-nav').addClass('is-hidden');
    jQuery('cd-primary-nav li.has-children a.selected').removeClass('selected');
    if ( jQuery('ul.cd-primary-nav li').hasClass('menu-is-active menu-is-open') ) {
      jQuery('ul.cd-primary-nav li').removeClass('menu-is-active menu-is-open');
    }
  }
});
